import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { TableStructure } from '@shared/components/table/models/table-structure.model';
import { PatientLinkComponentModule } from 'src/app/features/reports/components/patient-link/patient-link.component';
import { PhotoReportRecord } from '../photo-report.model';
import { TreatmentModule } from '@shared/components/treatment/treatment.module';
import { mapToStatusEnum } from '@/src/app/utils/treatment.utils';
import { FormStatus } from '@shared/enums/form-status.enum';
import { BaseReportTableComponent } from '@src/app/features/reports/components/base-report-table/base-report-table.component';
import { SimpleReportTableColumn } from '@src/app/features/reports/components/report-filters/models/report-data.model';
import { ReadonlyImageComponent } from '@shared/components/readonly-image/readonly-image.component';
import { TreatmentStatusIndicatorComponent } from '@shared/components/treatment-status-indicator/treatment-status-indicator.component';
import { PatientLinkComponent } from '../../../../components/patient-link/patient-link.component';
import { EmptyTableStateComponent } from '@shared/components/empty-table-state/empty-table-state.component';
import { ReportType } from '@src/app/features/reports/components/report-filters/models/report-filters.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'stx-photo-report-table',
  templateUrl: './photo-report-table.component.html',
  styleUrls: ['./photo-report-table.component.scss'],
  imports: [MatPaginator, ReadonlyImageComponent, TreatmentStatusIndicatorComponent, PatientLinkComponent, EmptyTableStateComponent]
})
export class PhotoReportTableComponent extends BaseReportTableComponent<PhotoReportRecord> implements OnInit, OnDestroy {
  readonly reportType: ReportType = 'PHOTO_REPORT';
  displayedColumns: string[] = [];
  columns: SimpleReportTableColumn[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.onInit();

    this.subSink.sink = this.reportTableDataService.tableStructure$.subscribe((tableStructure: TableStructure<PhotoReportRecord[]>) => {
      this.columns = tableStructure?.labels || [];
      this.displayedColumns = this.columns.map(a => a.name);
    });
  }

  ngOnDestroy() {
    this.reportTableDataService.flush();
    super.onDestroy();
  }

  public mapToStatusEnum(status: number | null): FormStatus | null {
    return mapToStatusEnum(status);
  }
}

@NgModule({
  imports: [CommonModule, MatPaginatorModule, PatientLinkComponentModule, TreatmentModule, PhotoReportTableComponent],
  exports: [PhotoReportTableComponent]
})
export class PhotoReportTableComponentModule {}
